import _ from "lodash";
import client from "lib/apolloClient/client";
import { getGlobalGradesQuery } from "./CurriculumOptionsQuery";

export const getGlobalGradesFromCache = () => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getGlobalGradesQuery,
    });
  } catch (error) {
    return {};
  }
  if (queryData != null) {
    return _.get(queryData, "platform.globalGrades", []);
  } else return {};
};
